import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_TITLE = 'Sofia Surgicals | Orthopaedic Implant & Instruments Manufacturers in India';
const DEFAULT_DESCRIPTION = 'Sofia Surgicals is a leading manufacturer, supplier and exporter of high-quality orthopaedic implants, trauma products and surgical instruments in India.';
const DEFAULT_KEYWORDS = 'orthopaedic implants, surgical instruments, bone plates, trauma implants, spine implants, orthopaedic manufacturer India, Sofia Surgicals';
const DEFAULT_IMAGE = 'https://api.sofiasurgicals.com/Public/1786348373127orthopedic%20implant%20manufacturers%202%20(1).png';
const SITE_URL = 'https://sofiasurgicals.com';

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
}) => {
  const fullTitle = title
    ? title.toLowerCase().includes('sofia surgicals')
      ? title
      : `${title} | Sofia Surgicals`
    : DEFAULT_TITLE;

  const canonicalUrl = url
    ? url.startsWith('http')
      ? url
      : `${SITE_URL}${url.startsWith('/') ? '' : '/'}${url}`
    : SITE_URL;

  const metaImage = image
    ? image.startsWith('http')
      ? image
      : `${SITE_URL}${image.startsWith('/') ? '' : '/'}${image}`
    : DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || DEFAULT_DESCRIPTION} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || DEFAULT_DESCRIPTION} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="Sofia Surgicals" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || DEFAULT_DESCRIPTION} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
};

export default SEO;
